import { FC } from "react";
import "./styles.scss";

interface IProps {
  title: string;
  forModal?: boolean;
  onClick?: () => void;
  disable?: boolean;
}

export const WhiteButton: FC<IProps> = ({
  title,
  disable,
  forModal,
  onClick,
}) => {
  return (
    <button
      type="button"
      className={`home-page-white-button ${
        forModal ? "home-page-white-button_padding" : ""
      } ${disable ? "home-page-black-disable" : ""}`}
      onClick={onClick}
    >
      {title}
    </button>
  );
};
